import { render, staticRenderFns } from "./InvBatMtbxPrintPage2.vue?vue&type=template&id=4fdfee68"
import script from "./InvBatMtbxPrintPage2.vue?vue&type=script&lang=js"
export * from "./InvBatMtbxPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports